<template>
    <div>
        <v-dialog v-model="imgdialog" max-width="450px">
            <v-card tile color="#f4f6f6">
                <v-card-text>
                    <v-container>
                        <v-img
                                contain
                                max-height="150"
                                :src="selectedSrc"
                        ></v-img>
                    </v-container>
                </v-card-text>

                <v-divider class="primary"/>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="error" @click="() => {imgdialog=false}">
                        Back
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" max-width="450px" persistent>
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                    <v-icon dark>
                        mdi-plus
                    </v-icon>
                    Create
                </v-btn>
            </template>
            <v-card tile>
                <v-card-title class="primary white--text">
                    <span class="text-h5"><v-icon large color="white" class="mr-2">{{formIcon}}</v-icon>{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="12" class="my-2 d-flex justify-center" v-if="selectedImage">
                                <v-img
                                        contain
                                        max-height="150"
                                        :src="selectedImage"
                                ></v-img>
                            </v-col>
                            <v-col cols="12">
                                <v-file-input
                                        label="Cover"
                                        outlined
                                        dense
                                        @change="getImage"
                                        v-model="editedItem.img_url"
                                        prepend-icon=""
                                        append-icon="mdi-image"
                                ></v-file-input>
                            </v-col>

                            <v-col cols="12" class="my-2 d-flex justify-center" v-if="selectedSocialImage">
                                <v-img
                                        contain
                                        max-height="150"
                                        :src="selectedSocialImage"
                                ></v-img>
                            </v-col>
                            <v-col cols="12">
                                <v-file-input
                                        label="Social Cover"
                                        outlined
                                        dense
                                        @change="getSocialImage"
                                        v-model="editedItem.social_img_url"
                                        prepend-icon=""
                                        append-icon="mdi-image"
                                ></v-file-input>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field
                                        outlined
                                        dense
                                        v-model="editedItem.name"
                                        :error-messages="nameErrors"
                                        required
                                        @input="editedIndex == -1 ? $v.editedItem.name.$touch(): null"
                                        @blur="editedIndex == -1 ? $v.editedItem.name.$touch(): null"
                                        label="Name"
                                        append-icon="mdi-rename-box"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                        :items="['White','Black']"
                                        outlined
                                        dense
                                        v-model="editedItem.font_colour"
                                        :error-messages="font_colourErrors"
                                        required
                                        @input="editedIndex == -1 ? $v.editedItem.font_colour.$touch(): null"
                                        @blur="editedIndex == -1 ? $v.editedItem.font_colour.$touch(): null"
                                        label="Font color"
                                        append-icon="mdi-brush"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                        :items="['White','Black']"
                                        outlined
                                        dense
                                        v-model="editedItem.social_font_colour"
                                        :error-messages="social_font_colourErrors"
                                        required
                                        @input="editedIndex == -1 ? $v.editedItem.social_font_colour.$touch(): null"
                                        @blur="editedIndex == -1 ? $v.editedItem.social_font_colour.$touch(): null"
                                        label="Social Font color"
                                        append-icon="mdi-brush"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                        dense
                                        outlined
                                        v-model="editedItem.type"
                                        :items="['Political', 'Business', 'NGO']"
                                        label="Type"
                                        :error-messages="typeErrors"
                                        required
                                        @input="editedIndex == -1 ? $v.editedItem.type.$touch(): null"
                                        @blur="editedIndex == -1 ? $v.editedItem.type.$touch(): null"
                                        append-icon="mdi-briefcase"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-select
                                        v-show="editedItem.type == 'Political'"
                                        outlined
                                        dense
                                        :items="politicals"
                                        v-model="editedItem.political_party"
                                        :error-messages="political_partyErrors"
                                        required
                                        @input="editedIndex == -1 ? $v.editedItem.political_party.$touch(): null"
                                        @blur="editedIndex == -1 ? $v.editedItem.political_party.$touch(): null"
                                        label="Political party"
                                        append-icon="mdi-gamepad-circle"
                                ></v-select>
                            </v-col>
                            <v-col cols="12">
                                <label>Is Premium</label>
                                <v-radio-group
                                        required
                                        v-model="editedItem.is_prime"
                                        row>
                                    <v-radio
                                            label="Yes"
                                            :value="1"
                                    ></v-radio>
                                    <v-radio
                                            label="No"
                                            :value="0"
                                    ></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-alert v-if="error" dense type="error">
                                    {{error}}
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-divider class="primary"/>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="error" @click="close">
                        Cancel
                    </v-btn>
                    <v-btn color="success" @click="save">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="error white--text"
                >
                    <v-icon color="white" class="mr-2">mdi-delete</v-icon>
                    You sure you want to delete this item?
                </v-card-title
                >
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="closeDelete"
                    >Cancel
                    </v-btn
                    >
                    <v-btn color="success" @click="deleteItemConfirm"
                    >OK
                    </v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-data-table
                :headers="headers"
                :items="data"
                sort-by="calories"
                class="elevation-3"
        >
            <template v-slot:item.img_url="{item}">
                <v-avatar class="profile my-2" color="grey" size="80" tile @click="openImage(item.img_url)">
                    <v-img contain v-if="item.img_url" :src="item.img_url"></v-img>
                </v-avatar>
            </template>
            <template v-slot:item.social_img_url="{item}">
                <v-avatar class="profile my-2" color="grey" size="80" tile @click="openImage(item.social_img_url)">
                    <v-img contain v-if="item.social_img_url" :src="item.social_img_url"></v-img>
                </v-avatar>
            </template>
            <template v-slot:item.party_name="{item}">
                <span>{{ item.type === 'NGO' ? '' : item.party_name }}</span>
            </template>
            <template v-slot:item.is_prime="{item}">
                <p>{{ parseInt(item.is_prime) > 0 ? 'Yes' : 'No' }}</p>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small class="mr-2 warning--text" @click="editItem(item)">
                    mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)" class="error--text">
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-progress-circular
                        v-if="loading"
                        indeterminate
                        color="secondary"
                ></v-progress-circular>
                <v-icon
                        v-else
                        x-large
                        color="grey lighten-1"
                >
                    mdi-tray-remove
                </v-icon>

            </template>
        </v-data-table>
    </div>
</template>
<script>
    import {required} from 'vuelidate/lib/validators'
    import {validationMixin} from 'vuelidate'

    export default {
        name: 'Frames',
        mixins: [validationMixin],
        data: () => ({
            imgdialog: false,
            selectedSrc: null,
            selectedSocialImage: null,
            headers: [
                {
                    text: 'Cover',
                    value: 'img_url',
                    sortable: false,
                    align: 'start'
                },
                {
                    text: 'Social Cover',
                    value: 'social_img_url',
                    sortable: false,
                    align: 'start'
                },
                {text: 'Name', value: 'name'},
                {text: 'Frame Type', value: 'type'},
                {text: 'Front Color', value: 'font_colour'},
                {text: 'Social Font Color', value: 'social_font_colour'},
                {text: 'Party Name', value: 'party_name'},
                {text: 'Premium', value: 'is_prime', sortable: false},
                {text: 'Actions', value: 'actions', sortable: false},
            ],
            data: [],
            apiUrl: process.env.VUE_APP_API_URL,
            loading: true,
            dialog: false,
            dialogDelete: false,
            error: '',
            editedIndex: -1,
            selectedImage: null,
            politicals: [],
            editedItem: {
                name: '',
                img_url: null,
                social_img_url: null,
                font_colour: '',
                social_font_colour: '',
                political_party: '',
                type: '',
                is_prime: 0,
            },
            defaultItem: {
                name: '',
                img_url: null,
                social_img_url: null,
                font_colour: '',
                social_font_colour: '',
                political_party: '',
                type: '',
                is_prime: 0,
            },
        }),
        created() {
            this.getFrames();
            this.getAllPoliticals()
        },
        methods: {
            openImage(src) {
                this.selectedSrc = src
                this.imgdialog = true
            },
            editItem(item) {
                this.selectedImage = item.img_url
                this.selectedSocialImage = item.social_img_url
                this.editedIndex = this.data.indexOf(item);
                this.editedItem = Object.assign({}, item);

                if(this.editedItem.party_id > 0){
                    this.editedItem.political_party = this.editedItem.party_id;
                }

                this.editedItem.img_url = null;
                this.dialog = true;
                console.log(this.editedItem);
            },
            deleteItem(item) {
                this.editedIndex = this.data.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editedItem.is_prime = item.is_prime;
                this.dialogDelete = true;
            },
            deleteItemConfirm() {
                this.deleteFrame(this.editedItem.id)
                this.closeDelete();
            },
            close() {
                this.selectedImage = null
                this.selectedSocialImage = null
                this.dialog = false;
                this.$v.$reset()
                this.error = ''
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                });
            },
            closeDelete() {
                this.dialogDelete = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                });
            },
            save() {
                this.editedIndex == -1 ? this.addFrame() : this.updateFrame()
            },
            //Frames API Calls
            getFrames() {
                this.loading = true
                this.$Axios
                    // original - get-frames
                    // new added - get-frames-demo
                    .get('get-frames')
                    .then((res) => {
                        // original - AllFrames
                        // new added - data
                        this.data = res.data["data"];
                    })
                    .catch((e) => {
                        console.log(e);
                    })
                    .finally(() => {
                        this.loading = false
                    })
            },
            getImage() {
                let formData = new FormData();
                formData.append('img_url', this.editedItem.img_url);
                this.$Axios({
                    method: 'post',
                    url: 'add-frame-image',
                    data: formData,
                    headers: {'Content-Type': 'multipart/form-data'},
                })
                    .then(({data}) => {
                        this.selectedImage = data.data.bannerImageUrl
                    })
                    .catch((e) => {
                        console.log(e)
                    });
            },
            getSocialImage() {
                let formData = new FormData();
                formData.append('social_img_url', this.editedItem.social_img_url);
                this.$Axios({
                    method: 'post',
                    url: 'add-frame-social-image',
                    data: formData,
                    headers: {'Content-Type': 'multipart/form-data'},
                })
                    .then(({data}) => {
                        this.selectedSocialImage = data?.data?.frameSocialImageUrl;
                    })
                    .catch((e) => {
                        console.log(e)
                    });
            },
            addFrame() {

                this.error = ''
                this.$v.$touch()
                if (this.$v.$error && this.editedItem.type == "Political") {
                    return
                } else {
                    if (this.$v.editedItem.img_url.$error || this.$v.editedItem.font_colour.$error || this.$v.editedItem.name.$error || this.$v.editedItem.type.$error) {
                        return
                    }
                }

                let data = {}
                data.name = this.editedItem.name
                data.img_url = this.selectedImage
                data.social_img_url = this.selectedSocialImage
                data.font_colour = this.editedItem.font_colour
                data.social_font_colour = this.editedItem.social_font_colour
                data.is_prime = this.editedItem.is_prime
                data.type = this.editedItem.type
                if (this.editedItem.type == 'Political') data.political_party = this.editedItem.political_party

                this.$Axios
                    .post('add-frame', data)
                    .then(() => {
                        this.getFrames();
                        this.close();
                    })
                    .catch((e) => {
                        if(e.response.status === 422){
                            alert('Missing required fields!');
                        }else{
                            console.log(e?.response);
                        }
                    });
            },
            updateFrame() {
                this.error = ''
                this.$v.$touch()
                let data = {}
                if (this.editedItem.name) data.name = this.editedItem.name
                if (this.editedItem.img_url) data.img_url = this.selectedImage
                if (this.editedItem.social_img_url) data.social_img_url = this.selectedSocialImage
                if (this.editedItem.font_colour) data.font_colour = this.editedItem.font_colour
                if (this.editedItem.social_font_colour) data.social_font_colour = this.editedItem.social_font_colour
                console.log(this.editedItem.is_prime !== undefined, this.editedItem.is_prime !== null, this.editedItem.is_prime);
                if (this.editedItem.is_prime !== undefined && this.editedItem.is_prime !== null) data.is_prime = this.editedItem.is_prime.toString()
                if (this.editedItem.type == 'Business') data.type = this.editedItem.type
                if (this.editedItem.type && this.editedItem.political_party) data.type = this.editedItem.type
                if (this.editedItem.type == 'Political') data.political_party = this.editedItem.political_party
                if (this.editedItem.type.toLowerCase() === 'ngo') data.type = 'NGO'

                let formData = new FormData();
                if (this.editedItem.name) formData.append('name', this.editedItem.name);
                if (this.editedItem.img_url) formData.append('img_url', this.selectedImage);
                if (this.editedItem.social_img_url) formData.append('social_img_url', this.selectedSocialImage);
                if (this.editedItem.font_colour) formData.append('font_colour', this.editedItem.font_colour);
                if (this.editedItem.social_font_colour) formData.append('social_font_colour', this.editedItem.social_font_colour);
                if (this.editedItem.political_party) formData.append('political_party', this.editedItem.political_party)
                if (this.editedItem.is_prime) formData.append('political_party', this.editedItem.is_prime)
                if (this.editedItem.type) formData.append('type', this.editedItem.type);
                console.log('adding item : ', formData);
                this.$Axios.put('update-frame?id=' + this.editedItem.id, data)
                    .then(() => {
                        this.getFrames();
                        this.close();
                    })
                    .catch((e) => {
                        console.log(e)
                    });
            },
            deleteFrame(id) {
                this.$Axios
                    .delete('delete-frame?id=' + id)
                    .then(() => {
                        this.getFrames();
                    })
                    .catch((e) => {
                        console.log(e);
                    })
            },
            getAllPoliticals() {
                this.$Axios
                    .get('get-political-party')
                    .then((res) => {
                        this.politicals = res.data["AllParties"].map((el) => {
                            return {value: el.id, text: el.party_name}
                        })
                    })
                    .catch((e) => {
                        console.log(e);
                    })
            }
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Frame' : 'Edit Frame';
            },
            formIcon() {
                return this.editedIndex === -1 ? 'mdi-plus' : 'mdi-edit';
            },
            filtredItems() {
                if (this.filter) return this.desserts.filter(item => item.name.includes(this.filter)
                    || item.license.includes(this.filter)
                    || item.email.includes(this.filter)
                    || item.db.includes(this.filter))
                else return this.desserts
            },
            //// Vuelidate Errors
            nameErrors() {
                const errors = []
                if (!this.$v.editedItem.name.$dirty) return errors
                !this.$v.editedItem.name.required && errors.push('Name is required !')
                return errors
            },
            img_urlErrors() {
                const errors = []
                if (!this.$v.editedItem.img_url.$dirty) return errors
                !this.$v.editedItem.img_url.required && errors.push('Cover is required !')
                return errors
            },
            social_img_urlErrors() {
                const errors = []
                if (!this.$v.editedItem.social_img_url.$dirty) return errors
                !this.$v.editedItem.social_img_url.required && errors.push('Social Frame is required !')
                return errors
            },
            font_colourErrors() {
                const errors = []
                if (!this.$v.editedItem.font_colour.$dirty) return errors
                !this.$v.editedItem.font_colour.required && errors.push('Font color is required')
                return errors
            },
            social_font_colourErrors() {
                const errors = []
                if (!this.$v.editedItem.social_font_colour.$dirty) return errors
                !this.$v.editedItem.social_font_colour.required && errors.push('Social Font color is required')
                return errors
            },
            political_partyErrors() {
                const errors = []
                if (!this.$v.editedItem.political_party.$dirty) return errors
                !this.$v.editedItem.political_party.required && errors.push('Political party is required')
                return errors
            },
            typeErrors() {
                const errors = []
                if (!this.$v.editedItem.type.$dirty) return errors
                !this.$v.editedItem.type.required && errors.push('Type is required')
                return errors
            },
        },
        watch: {
            dialog(val) {
                val || this.close();
            },
            dialogDelete(val) {
                val || this.closeDelete();
            },
        },
        validations: {
            editedItem: {
                name: {
                    required
                },
                img_url: {
                    required,
                },
                social_img_url: {
                    required,
                },
                font_colour: {
                    required
                },
                social_font_colour: {
                    required
                },
                political_party: {
                    required
                },
                is_prime: {
                    required
                },
                type: {
                    required
                }
            },
        },
    };
</script>